import * as PusherPushNotifications from '@pusher/push-notifications-web'
import type { UserId } from '@previo/codebooks'
import { RegistrationState } from '@pusher/push-notifications-web'
import { useUserNotificationsAPI } from '~/plugins/push-notifications/client/http/UserNotificationAPI'
import type { IPushNotificationClient } from '~/plugins/push-notifications/client/types/IPushNotificationClient'

export class PusherBeamsClient implements IPushNotificationClient {
  constructor(private instance: PusherPushNotifications.Client) {}

  async start(userId: UserId): Promise<void> {
    await this.instance.stop()

    try {
      await this.instance.start()
      await this.instance.setUserId(userId.toString(), useUserNotificationsAPI())
    } catch (e) {
      if (e instanceof Error && e.name === 'NotAllowedError') {
        // User has blocked notifications
        return
      }

      throw e
    }

    return Promise.resolve()
  }

  async stop(): Promise<void> {
    return this.instance.stop()
  }

  canAutoRequestPermission(): boolean {
    return true
  }

  deactivate(): Promise<void> {
    return this.instance.stop()
  }

  activate(userId: UserId): Promise<void> {
    return this.start(userId)
  }

  async isDeniedByBrowser(): Promise<boolean> {
    const state = await this.instance.getRegistrationState()

    return state === RegistrationState.PERMISSION_DENIED
  }

  async isSubscribed(): Promise<boolean> {
    const state = await this.instance.getRegistrationState()

    return state === RegistrationState.PERMISSION_GRANTED_REGISTERED_WITH_BEAMS
  }
}
